import { colors as colorChart } from "./Variants/WerfenOne"

/*
 *  @Description:   This file contains all the colors used by the app.
 *                   
 */

export const Black = colorChart.Black;
export const White = colorChart.White;

// WERFEN COLORS
export const WerfenColor = colorChart.WerfenColor;
export const WerfenColorMid = colorChart.WerfenColorMid;
export const WerfenColorLight = colorChart.WerfenColorLight;
export const WerfenSecondaryColor = colorChart.WerfenSecondaryColor;

export const WerfenColor2 = colorChart.WerfenColor2;
export const WerfenColor3 = colorChart.WerfenColor3;
export const WerfenColor4 = colorChart.WerfenColor4;
export const WerfenColor5 = colorChart.WerfenColor5;

// SUPPORT COLORS
export const WerfenFormFieldColor = colorChart.WerfenFormFieldColor;
export const WerfenFormTextColor = colorChart.WerfenFormTextColor;
export const WerfenFormIconColor = colorChart.WerfenFormIconColor;
export const WerfenFormIconBackgroundColor = colorChart.WerfenFormIconBackgroundColor;

//CONSTRAST COLOR
export const WerfenColorContrast = colorChart.WerfenColorContrast;

//COOL GRAY
export const CoolGray = colorChart.CoolGray;
export const CoolGray2 = colorChart.CoolGray2;
export const CoolGray3 = colorChart.CoolGray3;
// export const CoolGray4 = colorChart.CoolGray4;
// export const CoolGray5 = colorChart.CoolGray5;

//DARK COLORS
export const Dark = colorChart.Dark;
export const Dark2 = colorChart.Dark2;
export const Dark3 = colorChart.Dark3;
export const Dark4 = colorChart.Dark4;

//FX COLORS
export const Shadow = colorChart.Shadow;
export const SwitchColor = colorChart.SwitchColor;
export const StripedRowColor = colorChart.StripedRowColor;
export const HoverRowColor = colorChart.HoverRowColor;

// ADDITIONAL COLORS
export const OfflineColor = colorChart.OfflineColor;
export const SAPBadgeColor = colorChart.SAPBadgeColor;
export const IframeVideoColor = colorChart.IframeVideoColor;
export const ExtLinkColor = colorChart.ExtLinkColor;
export const SuggestionHoverColor = colorChart.SuggestionHoverColor;
export const SuggestionBoxEntryColor = colorChart.SuggestionBoxEntryColor;
export const SuggestionHoverColorActive = colorChart.SuggestionHoverColorActive;
export const ActiveFilterIndicatorColor = colorChart.ActiveFilterIndicatorColor;
export const CarouselItemDataColor = colorChart.CarouselItemDataColor;

// RGB GRAYS BY OPACITY PERCENTAGE
export const Gray5 = colorChart.Gray5;
export const Gray12 = colorChart.Gray12;
export const Gray20 = colorChart.Gray20;
export const Gray25 = colorChart.Gray25;
export const Gray60 = colorChart.Gray60;
